import { Drawer } from "antd";
import { INote } from "notes/models";
import { NotesList } from "../notes-list/NotesList";
import "./NotesDrawer.scss";

type NotesDrawerProps = {
  open: boolean;
  onClose: () => void;
  data: INote[];
  hasMore: boolean;
  onLoadMore: () => void;
  loading: boolean;
  onRefetch: () => void;
};

export const NotesDrawer = ({
  open,
  onClose,
  data,
  hasMore,
  onLoadMore,
  loading,
  onRefetch,
}: NotesDrawerProps) => {
  return (
    <Drawer
      title="All Notes"
      placement="right"
      width={500}
      onClose={onClose}
      open={open}
      className="notes-drawer"
      destroyOnClose
    >
      <NotesList
        title=""
        showCard={false}
        showProjectName
        allowDismiss
        height={window.innerHeight - 120}
        data={data}
        hasMore={hasMore}
        onLoadMore={onLoadMore}
        loading={loading}
        onRefetch={onRefetch}
      />
    </Drawer>
  );
};
